import { DecimalPipe } from '@angular/common';
import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toMoney',
  standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class ToMoneyPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  transform(value: string | number, ...args: string[]): string {
    const formatPattern = Boolean(args?.length) ? args[0] : '0.0-0';

    const transformedValue = this.decimalPipe.transform(value, formatPattern);

    return `${transformedValue} ₪`;
  }
}
